import React, {FC} from "react";
import {useRouter} from "next/router";
import {useSelector} from "react-redux";
import {IState} from "../../../../types/state";
import {TranslationsType} from "../../../../types/homePageTypes";

const NewSearch: FC<{ translationsData: TranslationsType }> = ({translationsData}) => {

    const router = useRouter()

    const pageUrl = useSelector((state: IState) => state.smartSearch.smartSearchPageUrl)

    return <div className="new-search-feature">
        <div onClick={() => {
            router.push(pageUrl)
            setTimeout(() => {
                router.reload()
            }, 1000)
        }

        }>
            <span>
                {translationsData.NewSearch}
            </span>
        </div>

    </div>


}

export default NewSearch
